// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T9JQSaXUsHTEzk {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  scroll-margin: 80px;
}
.T9JQSaXUsHTEzk[hidden] {
  display: none;
}
.T9JQSaXUsHTEzk.u37B22F3L3ujIm {
  opacity: 0.4;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listCard": `T9JQSaXUsHTEzk`,
	"isDragging": `u37B22F3L3ujIm`
};
export default ___CSS_LOADER_EXPORT___;
